import React from 'react'

import type { Contact } from '~/api/graphql/generated/types'

import { ClinicBrief } from './ClinicBrief'

import styles from './ClinicSearchCard.module.scss'

export interface ClinicSearchCardProps {
  contact: Contact
  onClick: () => void
  onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void
}

const getContactAriaLabel = (contact: Contact): string => {
  const parts = [contact.name ?? 'Unknown clinic name']
  const addressParts = [
    contact.address,
    contact.city,
    contact.state,
    contact.zip,
  ].filter(Boolean)
  if (addressParts.length > 0) {
    parts.push(addressParts.join(', '))
  }
  if (contact.phone) {
    parts.push(contact.phone)
  }
  return parts.join('. ')
}

const ClinicSearchCard: React.FC<ClinicSearchCardProps> = ({
  contact,
  onClick,
  onKeyDown,
}) => {
  const cardId = contact.id

  return (
    <div
      aria-label={getContactAriaLabel(contact)}
      aria-selected={false}
      className={styles.clinicCard}
      id={cardId}
      role="option"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <ClinicBrief contact={contact} />
    </div>
  )
}

export default ClinicSearchCard
